import FormInput from './Input';
import * as React from 'react';

interface Props {
    labelProps: {
        labelText?: string;
        removeBoldFont?: boolean;
    };
    inputProps: {
        id: string;
        name: string;
        required?: boolean;
        value?: string;
        placeholder?: string;
        readOnly?: boolean;
        disabled?: boolean;
    };
    helpTextProps?: {
        helpText: string;
        helpTextClass?: string;
    };
    onChange: (inputName: string, newValue: string) => void;
    controlCssClass?: string;
}

const FormPhoneInput = (props: Props) => {
    return (
        <FormInput
            inputProps={{
                id: props.inputProps.id,
                name: props.inputProps.name,
                type: 'tel',
                placeholder: props.inputProps.placeholder || '(444) 444-4444',
                value: props.inputProps.value || '',
                required: props.inputProps.required,
                pattern: '\\(\\d{3}\\) \\d{3}-\\d{4}',
                mask: '(999) 999-9999',
                readOnly: props.inputProps.readOnly,   
                disabled: props.inputProps.disabled,
            }}
            labelProps={{
                labelText: props.labelProps.labelText,
                invalidText: 'Please enter a valid phone number',
                removeBoldFont: props.labelProps.removeBoldFont
            }}
            helpTextProps={props.helpTextProps}
            onChange={props.onChange}
            controlCssClass={props.controlCssClass}
        />
    );
};

export default FormPhoneInput;



// WEBPACK FOOTER //
// ./src/components/common/form/PhoneInput.tsx